import { usePhotoUrl } from "@/lib/photo";

export const Brand = ({ light = false }) => (
  <div className={`bg-white keep-white rounded-xl px-2 py-1 ${light ? "shadow-md ring-1 ring-white/70" : "ring-1 ring-slate-200/70"}`} data-testid="brand-logo">
    <img src="/brand-banner.webp" alt="Credit Union Tuah Talino - Koperasi Simpan Pinjam" className="h-11 w-auto max-w-[200px] object-contain" />
  </div>
);

export const SubHeader = ({ title, onBack, right }) => (
  <div className="flex items-center gap-3 px-5 pt-1 pb-3">
    {onBack && (
      <button onClick={onBack} data-testid="back-button" className="p-1 -ml-1 rounded-full hover:bg-slate-200 transition-colors">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
      </button>
    )}
    <h1 className="text-xl font-bold text-slate-900 flex-1" data-testid="page-title">{title}</h1>
    {right}
  </div>
);

export const Row = ({ icon: Icon, label, value, testid }) => (
  <div className="flex items-center justify-between py-3 border-b border-slate-100 last:border-0">
    <div className="flex items-center gap-3 text-sm text-slate-700">
      {Icon && <Icon className="h-5 w-5 text-slate-500" />}
      {label}
    </div>
    <div className="text-sm font-bold text-slate-900" data-testid={testid}>{value}</div>
  </div>
);

export const StatusBadge = ({ status, label, testid }) => {
  const styles = {
    pending: "bg-amber-50 text-amber-700 border-amber-200",
    disetujui: "bg-emerald-50 text-emerald-700 border-emerald-200",
    aktif: "bg-emerald-50 text-emerald-700 border-emerald-200",
    lunas: "bg-blue-50 text-blue-800 border-blue-200",
    ditolak: "bg-red-50 text-red-700 border-red-200",
    nonaktif: "bg-slate-100 text-slate-600 border-slate-200",
  };
  const labels = { pending: "Menunggu", disetujui: "Disetujui", aktif: "Aktif", lunas: "Lunas", ditolak: "Ditolak", nonaktif: "Nonaktif" };
  return (
    <span data-testid={testid} className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[11px] font-semibold ${styles[status] || styles.pending}`}>
      {label || labels[status] || status}
    </span>
  );
};

export const EmptyState = ({ icon: Icon, title, text, children, testid }) => (
  <div data-testid={testid} className="bg-white border border-dashed border-slate-300 rounded-2xl p-6 text-center">
    {Icon && <Icon className="h-9 w-9 mx-auto text-slate-400" />}
    <div className="font-semibold text-slate-800 mt-2">{title}</div>
    {text && <p className="text-xs text-slate-500 mt-1">{text}</p>}
    {children}
  </div>
);

export const UserPhoto = ({ user, className, testid, bare }) => {
  const url = usePhotoUrl(user);
  const src = url || (user.photo_path ? null : user.picture);
  if (!src && bare) return <div data-testid={testid} className={className} />;
  return src ? (
    <img src={src} alt="" data-testid={testid} className={`${className} object-cover bg-slate-200`} />
  ) : (
    <div data-testid={testid} className={`${className} bg-blue-800 text-white font-bold flex items-center justify-center`}>
      {user.name?.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase()}
    </div>
  );
};
